import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 36 36"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("rect", {
      width: "36",
      height: "36",
      fill: "#fff",
      rx: "8"
    }, null, -1),
    _createElementVNode("path", {
      stroke: "#4CA22E",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.6",
      d: "M13 23h6.667M10.5 26.333h15M19.665 26.333a5.833 5.833 0 0 0 0-11.667h-.833M15.5 19.667h1.667M15.499 18a1.666 1.666 0 0 1-1.667-1.667V13h5v3.333A1.667 1.667 0 0 1 17.165 18H15.5ZM18.001 13v-2.5a.833.833 0 0 0-.833-.834h-1.667a.833.833 0 0 0-.833.833V13"
    }, null, -1)
  ]))]))
}
export default { render: render }